var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TeamMemberSmall"},[_c('TeamMemberImage',{attrs:{"member":_vm.member}}),_c('Wrap',{staticClass:"body"},[_c('div',{staticClass:"head"},[_c('h4',[_vm._v(" "+_vm._s(_vm.member.name)+" ")]),_c('div',{staticClass:"role"},[_vm._v(" "+_vm._s(_vm.member.role)+" ")])]),_c('p',[_vm._v(" "+_vm._s(_vm.member.description)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }